export default function Menu(theme) {
	return {
		MUIDataTable: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.background.paper,
				},
			},
		},
		MUIDataTableToolbar: {
			styleOverrides: {
				filterPaper: {
					width: '400px',
				},
			},
		},
		MUIDataTableBodyCell: {
			styleOverrides: {
				root: {
					minWidth: 150,
				},
			},
		},
		MUIDataTableHeadCell: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.grey['200'],
					width: 300,
				},
			},
		},
		MUIDataTableSelectCell: {
			styleOverrides: {
				headerCell: {
					backgroundColor: theme.palette.grey['200'],
				},
			},
		},
	};
}
